import React from "react";
import { Badge, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import {
  SuggestionCard,
  SuggestionHeader,
  SuggestionTitle,
  SuggestionDescription,
  SuggestionIconWrapper,
  SuggestionActionButton,
} from './Styles';
import { Suggestion, PRIORITY_COLORS, COLOR_MAP } from './Constant';

interface SuggestionCardProps {
  suggestion: Suggestion;
  user?: any;
}

const SuggestionCardComponent: React.FC<SuggestionCardProps> = ({
  suggestion,
  user,
}) => {
  if (suggestion.condition && !suggestion.condition(user)) {
    return null;
  }

  const color = PRIORITY_COLORS[suggestion.category] || "blue";
  const colorValue = COLOR_MAP[color] || "#1890ff";

  return (
    <SuggestionCard>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <SuggestionHeader>
          <Badge
            status="processing"
            color={color}
            text={suggestion.category}
            style={{ fontSize: "12px", fontWeight: 600 }}
          />
          <SuggestionIconWrapper color={colorValue}>
            <FontAwesomeIcon icon={suggestion.icon} />
          </SuggestionIconWrapper>
        </SuggestionHeader>

        <div>
          <SuggestionTitle>{suggestion.title}</SuggestionTitle>
          <SuggestionDescription>
            {suggestion.description}
          </SuggestionDescription>
        </div>

        <SuggestionActionButton
          type="primary"
          icon={<FontAwesomeIcon icon={faBolt} />}
          bgColor={colorValue}
          borderColor={colorValue}
        >
          {suggestion.actionText}
        </SuggestionActionButton>
      </Space>
    </SuggestionCard>
  );
};

export default SuggestionCardComponent;